import { createContext } from "react";

/**
 * Whether the page around a drawer is the one on screen. A page you leave stays mounted (App keeps it,
 * hidden), and a drawer it opened is portaled to <body>, so it stayed over the next page — a chat opened
 * from elsewhere came up under 客户表's customer page. A page says here that it is off screen; its drawers
 * hide and keep their place (and what is typed in them) until it is back. Closing them instead would step
 * history back at the moment the next page stepped it forward, and undo that page change.
 * Pages that never say so are always on screen.
 */
export const PageShown = createContext(true);

/** Hidden, not unmounted: what is in the drawer stays as it was. */
export const HIDDEN = { display: "none" } as const;
